var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlainLtcLogoWhiteBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 15 210 50",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.26458333,0,0,0.26458334,19.38218,18.43132)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1.3333333,0,0,1.3333333,1.3333333,89.006667)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontVariant: "normal",
    fontWeight: 300,
    fontStretch: "normal",
    fontSize: "72px",
    fontFamily: "Corbel",
    writingMode: "lr-tb",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    x: 0,
    dx: "0 0 55.872002 0 181.584 0 55.872002",
    y: 0
  }, "L I K E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1.3333333,0,0,1.3333333,66.75128,151.12132)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontVariant: "normal",
    fontWeight: 300,
    fontStretch: "normal",
    fontSize: "20px",
    fontFamily: "Corbel",
    writingMode: "lr-tb",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#ffffff",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1,
    x: 0,
    dx: "0 0 11.64 0 11.64 0 15.52 0 15.52 0 11.64 0 11.64 0 11.64 0 11.64 0 11.64 0 11.64 0 11.64 0 11.64 0 11.64",
    y: 0
  }, "T A X & C O N S U L T I N G")), /*#__PURE__*/React.createElement("path", {
    d: "M 49.06291,23.99861 H 423.398",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1,
    transform: "matrix(1.3333333,0,0,-1.3333333,0,155.9328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 181.4543,49.62112 57.643,48.07189 42.1443,-48.07189 z",
    fill: "#670034",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1,
    transform: "matrix(1.3333333,0,0,-1.3333333,0,155.9328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 164.2714,49.62112 22.7217,35.2846 35.2845,-35.2846 z",
    fill: "#b9c7d5",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1,
    transform: "matrix(1.3333333,0,0,-1.3333333,0,155.9328)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlainLtcLogoWhiteBg);
export default __webpack_public_path__ + "static/media/Plain_LTC_Logo_WhiteBG.a259751b4857e12c66952868b5bb18ea.svg";
export { ForwardRef as ReactComponent };